module.exports = __webpack_public_path__ + "static/media/sort_up_icon.dd6ba0ce.svg";